<template>
  <div>
    <Card>
      <TablePaginate :columns="columns"
                     :data="staff_rebate_records"
                     :loading="loading"
                     :meta="meta"
                     :changePage="changePage"></TablePaginate>
    </Card>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import TablePaginate from '@/components/TablePaginate'
import { deleteButtonInTable, commonButtonInTable } from '@/libs/table-render'

export default {
  components: {
    TablePaginate
  },
  data () {
    return {
      columns: [
        {
          title: i18n.t('pages_promote_bill_info_869'),
          key: 'id',
          width: 100
        },
        {
          title: i18n.t('pages_customers_index_329'),
          key: 'promote_company_staff_username'
        },
        {
          title: i18n.t('pages_promote_company_bills_888'),
          key: 'total'
        },
        {
          title: i18n.t('pages_promote_company_bills_889'),
          key: 'created_at'
        },
        {
          title: i18n.t('pages_bookings_index_230'),
          key: 'description'
        },
        {
          title: i18n.t('pages_ai_image_163'),
          key: 'action',
          width: 280,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            const children = []
            children.push(
              commonButtonInTable(
                this,
                h,
                'success',
                i18n.t('pages_promote_company_bills_890'),
                this.checkBillInfo,
                [params.row.id]
              ),
              commonButtonInTable(
                this,
                h,
                'warning',
                i18n.t('pages_promote_company_bills_891'),
                this.updateRemark,
                [params.row.id, params.row.description]
              ),
              deleteButtonInTable(this, h, params)
            )
            return h('div', children)
          }
        }
      ]
    }
  },
  created () {
    this.changePage(1)
  },
  computed: {
    ...mapGetters('staff_rebate_record', ['staff_rebate_records', 'meta', 'loading'])
  },
  methods: {
    ...mapActions('staff_rebate_record', [
      'clearRecord',
      'index',
      'show',
      'create',
      'update',
      'destroy'
    ]),
    ...mapMutations('staff_rebate_record', ['changeQuery']),
    changePage (page) {
      this.changeQuery({ page, promote_company_staff_id: this.$route.params.id })
      this.index()
    },
    checkBillInfo (id) {
      this.$router.push(`/promote/staff/bills/${id}`)
    },
    updateRemark (id, description) {
      this.$prompt(i18n.t('pages_promote_company_bills_891'), i18n.t('pages_promote_companies_887'), {
        confirmButtonText: i18n.t('pages_combo_index_284'),
        cancelButtonText: i18n.t('pages_city_shop_freights_index_250'),
        inputValue: description,
        inputPattern: /./,
        inputErrorMessage: i18n.t('pages_promote_companies_886')
      }).then(({ value }) => {
        this.update({
          id,
          description: value
        })
      })
    }
  }
}
</script>
